import { TMessage } from "@/i18n/tt";
import { TMessageKey } from "@/i18n/types.gen";

export type AccountUserGroupType = "ACCOUNT_ADMINS" | "COMPANY_ADMINS" | "CUSTOM_ROLE";

export type AccountUserGroup = {
  grantee: string;
  type: AccountUserGroupType;
  name?: string;
  memberCount: number;
};

const userGroupLabels: { [key in Exclude<AccountUserGroupType, "CUSTOM_ROLE">]: TMessageKey } = {
  ACCOUNT_ADMINS: "enterprise-account.account-admin",
  COMPANY_ADMINS: "enterprise-account.visibility.group.company-admins",
};

export const accountUserGroupLabel = (group: AccountUserGroup): TMessage =>
  group.type === "CUSTOM_ROLE"
    ? { translated: group.name ?? "" }
    : { key: userGroupLabels[group.type] };

export const memberCountLabel = (group: AccountUserGroup): TMessage => ({
  key: "enterprise-account.visibility.member-count",
  params: { count: group.memberCount },
});

export const visibleGroups = (
  groups: AccountUserGroup[],
  visibleTo: string[],
): AccountUserGroup[] =>
  visibleTo.flatMap((grantee) => groups.find((group) => group.grantee === grantee) ?? []);

export const addableGroups = (
  groups: AccountUserGroup[],
  visibleTo: string[],
): AccountUserGroup[] => groups.filter((group) => !visibleTo.includes(group.grantee));
